/**
 * Cắt khoảng trắng đầu/cuối, khớp `StaffNewPassword.Normalize` bên backend (`#110`).
 *
 * Dùng cho mật khẩu mới (đếm độ dài + gửi) và lúc đăng nhập.
 * Không dùng cho ô mật khẩu hiện tại lúc đổi — BE `#110` cố ý không Trim chỗ đó.
 * Khoảng trắng **giữa** chuỗi giữ nguyên (`"123 4567"` vẫn là 8).
 */
export function normalizeStaffPassword(password: string): string {
  return password.trim();
}
